import { AccountManagementEvent } from '@/services/analytics/events';
import { InteractionTrackingType } from '@/services/analytics/platforms/adobe-analytics/models';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgCheckoutOrderPickupPreference',
})
export default class CmgCheckoutOrderPickupPreference extends Vue {
  get adaImageUrl(): string {
    return this.$appStore.state.cms.images.icons.ada.default;
  }

  get lowerShelfPreference(): boolean {
    const { profile } = this.$appStore.state.customer;
    return profile
      ? profile.bottomShelfPreference
      : false;
  }

  onSpace(event: KeyboardEvent) {
    event.preventDefault();
    this.toggleLowerShelfPreference();
  }

  toggleLowerShelfPreference() {
    const { profile } = this.$appStore.state.customer;

    if (profile) {
      const { bottomShelfPreference } = profile;
      this.$services.customer.setProfile({ ...profile, bottomShelfPreference: !bottomShelfPreference });
      this.$services.analytics.send(new AccountManagementEvent(this.lowerShelfPreference ? InteractionTrackingType.AccessiblePickupToggleOn : InteractionTrackingType.AccessiblePickupToggleOff));
    }

    this.updateCustomer();
  }

  updateCustomer() {
    this.$services.customer.updateCustomer({ bottomShelfPreference: this.lowerShelfPreference });
  }
}
